import { Link } from '~/commonComponents';
import { IUser } from '~/models';
import { Links } from '../../constants';
import OneLastStepSVG from '../../images/signup/success/oneLastStep.svg';
import { featureFlagManager } from '~/services/posthog';
import { TnCOffices } from '~/constants/ff.posthog';

export const POPUP_VALUES = {
  oneLastStep: {
    title: 'One Last Step',
    description:
      'We will be providing professionals that are employed through our PEO, GoTu’s Professional Employment Organization (PEO). Please read through and accept the Personnel Service Agreement to begin posting shifts!',
    buttonText: 'Done',
    image: OneLastStepSVG,
    type: 'psa',
    switchText: (
      <>
        I agree to GoTu’s{' '}
        <Link text="Personnel Service Agreement" href={Links.termsOfUseEmployee} />
      </>
    ),
  },
  termsAndConditions: {
    title: 'GoTu Terms and Conditions',
    description: <>Please read through and accept our updated Terms and Conditions.</>,
    buttonText: 'Confirm',
    type: 'gotuTerms',
    image: null,
    switchText: (
      <>
        I agree to <Link text="Terms and Conditions" href={Links.termsOfUse} />
      </>
    ),
  },
  termsAndConditionsEmployee: {
    title: 'GoTu Terms and Conditions',
    description: <>Please read through and accept our updated Terms and Conditions.</>,
    buttonText: 'Confirm',
    type: 'both',
    image: null,
    switchText: (
      <>
        I agree to <Link text="Terms and Conditions" href={Links.termsOfUse} /> and{' '}
        <Link text="Personnel Service Agreement" href={Links.termsOfUseEmployee} />
      </>
    ),
  },
};

export const getPopupValues = (user: IUser, isNeedOldTnc: boolean, isNeedNewTnC: boolean) => {
  if (featureFlagManager.getFeatureFlag(TnCOffices)) {
    const isNeedTnc = isNeedOldTnc && !isNeedNewTnC;
    if (user?.workerClassification?.classificationType === 'employee') {
      if (!user?.office_info?.psaTerms?.accepted && isNeedTnc) {
        return POPUP_VALUES.termsAndConditionsEmployee;
      }

      if (!user?.office_info?.psaTerms?.accepted) {
        return POPUP_VALUES.oneLastStep;
      }
    }

    if (isNeedTnc) {
      return POPUP_VALUES.termsAndConditions;
    }

    return;
  }

  if (user?.workerClassification?.classificationType === 'employee') {
    if (!user?.office_info?.psaTerms?.accepted && isNeedOldTnc) {
      return POPUP_VALUES.termsAndConditionsEmployee;
    }

    if (!user?.office_info?.psaTerms?.accepted) {
      return POPUP_VALUES.oneLastStep;
    }

    if (isNeedOldTnc) {
      return POPUP_VALUES.termsAndConditions;
    }

    return null;
  }

  if (user?.workerClassification?.classificationType === 'contractor') {
    if (isNeedOldTnc) {
      return POPUP_VALUES.termsAndConditions;
    }
  }

  if (isNeedOldTnc) {
    return POPUP_VALUES.termsAndConditions;
  }

  return null;
};
